import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductPage from "../pages/product/page";
import AdminLoginPage from "../pages/admin/LoginPage";
import AdminLayout from "../pages/admin/AdminLayout";
import DashboardPage from "../pages/admin/DashboardPage";
import CategoriesPage from "../pages/admin/CategoriesPage";
import ProductsPage from "../pages/admin/ProductsPage";
import ProductFormPage from "../pages/admin/ProductFormPage";
import CollectionsPage from "../pages/admin/CollectionsPage";
import TextsPage from "../pages/admin/TextsPage";
import BannersPage from "../pages/admin/BannersPage";
import StoreInfoPage from "../pages/admin/StoreInfoPage";
import OrdersPage from "../pages/admin/OrdersPage";
import SettingsPage from "../pages/admin/SettingsPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/produto/:id",
    element: <ProductPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "categorias", element: <CategoriesPage /> },
      { path: "produtos", element: <ProductsPage /> },
      { path: "produtos/novo", element: <ProductFormPage /> },
      { path: "produtos/:id/editar", element: <ProductFormPage /> },
      { path: "colecoes", element: <CollectionsPage /> },
      { path: "textos", element: <TextsPage /> },
      { path: "banners", element: <BannersPage /> },
      { path: "informacoes", element: <StoreInfoPage /> },
      { path: "pedidos", element: <OrdersPage /> },
      { path: "configuracoes", element: <SettingsPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;